<div class="d-flex">             
  <div class="no-gutters">
    <div class="col-6">
      <div class="formulaire">
        <h1 *ngIf="element">{{ validerMessage.libelleElement | translate }}</h1>
        <h1 *ngIf="!element">{{ validerMessage.libelleDemande | translate }}</h1>
        <p>{{ validerMessage.description | translate }}</p>
        <fieldset>
          <legend>{{ validerMessage.choixForm | translate }}</legend>
          <p>{{ validerMessage.typeAvis | translate }}</p>
          <ul>
            <li *ngIf="form.controls.formIntitule.value">{{ form.controls.formIntitule.value }}</li>
          </ul>
        </fieldset>
        <fieldset>
          <legend (click)="openModal()">{{ validerMessage.choixSupport | translate }}</legend>
          <p>{{ validerMessage.supportDiffusion | translate }}</p>
          <ul>
            <li *ngFor="let diffuseur of canNavigateInStepper.intituleDiffuseur"> {{ diffuseur }}</li>
          </ul>
        </fieldset>
      </div>
    </div>
  </div>
</div>